// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NYI4f","content":"styles_content__3SKza","tableWrap":"styles_tableWrap__SpCJd"};